import { IMAGES, MENU } from "../data/site";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { Stamp } from "../components/Stamp";

const PHOTOS = [IMAGES.hero, IMAGES.cheeseX2, IMAGES.cheesyDog];

export default function MenuPage() {
  return (
    <>
      <section className="mx-auto max-w-6xl px-5 pb-10 pt-28 md:pt-36">
        <Breadcrumbs items={[{ label: "Menu", href: "/menu/" }]} />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Disiram Saus Sejak 2004</p>
        <h1 className="mt-3 font-display text-4xl uppercase tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Menu Burger Blenger
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-sand sm:text-lg">
          Burger dan hot dog dengan patty homemade dan saus mayo-BBQ luber yang
          sama sejak hari pertama. Harga khas lapak — menu dan harga terbaru bisa
          berubah, jadi cek langsung di outlet atau aplikasi pesan-antar.
        </p>
      </section>

      {/* Photo strip */}
      <section className="mx-auto max-w-6xl px-5" aria-label="Foto menu">
        <div className="grid grid-cols-3 gap-3 md:gap-5">
          {PHOTOS.map((img, i) => (
            <img
              key={img.src}
              src={img.src}
              alt={img.alt}
              width={img.w}
              height={img.h}
              loading={i === 0 ? undefined : "lazy"}
              decoding="async"
              className={`aspect-square w-full border border-white/10 object-cover ${
                i === 1 ? "translate-y-4 md:translate-y-8" : ""
              }`}
            />
          ))}
        </div>
      </section>

      {/* Nota — order ticket menu */}
      <section className="mx-auto max-w-3xl px-5 pb-24 pt-16 md:pt-24" data-testid="menu-ticket-section">
        <div className="ticket rotate-[0.4deg] p-6 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.8)] md:p-12" data-testid="menu-ticket">
          <header className="text-center">
            <p className="font-display text-3xl uppercase tracking-[0.1em] md:text-4xl">Nota Blenger</p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-coal/60">
              Est. 2004 • Barito–Blok M, Jaksel
            </p>
            <div className="mx-auto mt-5 h-8 w-44 bg-[repeating-linear-gradient(90deg,#110E0E_0_2px,transparent_2px_5px)]" aria-hidden="true" />
          </header>

          {MENU.map((cat) => (
            <section key={cat.category} className="mt-10">
              <h2 className="text-center font-mono text-sm font-semibold uppercase tracking-[0.3em]">
                — {cat.category} —
              </h2>
              <p className="mt-1 text-center font-mono text-[11px] uppercase tracking-[0.15em] text-coal/50">
                {cat.note}
              </p>
              <ul className="mt-5">
                {cat.items.map((item) => (
                  <li
                    key={item.id}
                    data-testid={`menu-item-${item.id}`}
                    className="ticket-row flex items-start justify-between gap-4 py-5"
                  >
                    <div>
                      <h3 className="font-display text-xl uppercase tracking-wide sm:text-2xl">
                        {item.name}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-coal/70">{item.desc}</p>
                    </div>
                    {item.tag && (
                      <Stamp className="mt-1 shrink-0 rotate-3 border-blood text-[11px] text-blood">
                        {item.tag}
                      </Stamp>
                    )}
                  </li>
                ))}
              </ul>
            </section>
          ))}

          <footer className="mt-10 border-t-2 border-dashed border-coal/30 pt-6 text-center">
            <p className="text-sm leading-relaxed text-coal/70">
              Menu &amp; harga bisa berbeda di tiap outlet dan berubah dari waktu
              ke waktu. Info terbaru: cek langsung di outlet atau aplikasi
              pesan-antar favoritmu.
            </p>
            <p className="mt-4 font-display text-lg uppercase tracking-[0.2em] text-blood">
              It's Worth The Wait
            </p>
          </footer>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-4">
          <a href="/lokasi/" data-testid="menu-location-button" className="btn-primary px-7 py-3.5 text-sm">
            Mampir ke Outlet
          </a>
          <a href="/tentang/" data-testid="menu-story-button" className="btn-ghost px-7 py-3.5 text-sm">
            Cerita di Balik Lapak
          </a>
        </div>
      </section>
    </>
  );
}
